export const LOT_STATUS_COLORS = {
  Open: '#10b981',
  Sold: '#ef4444',
  Reserved: '#f59e0b',
  Offer: '#007bff',
  ScheduledReserved: '#b89868'
};

export const AI_CONFIDENCE_COLORS = {
  confirmed: '#198754',
  high: '#198754',
  medium: '#f0ad4e',
  low: '#dc3545'
};
